function apiErrorRes(err) {
  if (!err) {
    return '';
  }

  if (err['details']) {
    return err['details'];
  } else if (err['detail']) {
    return err['detail'];
  }
  return '';
}

const obj = { apiErrorRes };

export default obj;
